export const getValue = (str: string) => {
  return Number(str?.replace(/\D/g, ''))
}
